<template>
  <v-row no-gutters justify="center">
    <v-col cols="6" class="text-center">
      <annotation-mode-button
        :image="coloredAssetUrls.arrow"
        :activeImage="activeAnnotationIcons.arrow"
        title="Arrow"
        @click="$emit('input', annotationModes.Arrow)"
        :size="size"
        :buttonMode="annotationModes.Arrow"
        :annotationMode="context.annotationMode"/>
      <annotation-mode-button
        :image="coloredAssetUrls.text"
        :activeImage="activeAnnotationIcons.text"
        title="Text"
        @click="$emit('input', annotationModes.Text)"
        :size="size"
        :buttonMode="annotationModes.Text"
        :annotationMode="context.annotationMode"/>
      <annotation-mode-button
        :image="coloredAssetUrls.redacted"
        :activeImage="activeAnnotationIcons.redacted"
        title="Redaction"
        @click="$emit('input', annotationModes.Redact)"
        :size="size"
        :buttonMode="annotationModes.Redact"
        :annotationMode="context.annotationMode"/>
      <annotation-mode-button
        :image="coloredAssetUrls.outlined"
        :activeImage="activeAnnotationIcons.outlined"
        title="Outline Box"
        @click="$emit('input', annotationModes.Outline)"
        :size="size"
        :buttonMode="annotationModes.Outline"
        :annotationMode="context.annotationMode"/>
      <annotation-mode-button
        :image="coloredAssetUrls.freehand"
        :activeImage="activeAnnotationIcons.freehand"
        title="Free Hand Tool"
        @click="$emit('input', annotationModes.FreeHandLine)"
        :size="size"
        :buttonMode="annotationModes.FreeHandLine"
       :annotationMode="context.annotationMode"/>
      <annotation-mode-button
        :image="coloredAssetUrls.continuous"
        :activeImage="activeAnnotationIcons.continuous"
        title="Continuous Draw"
        @click="$emit('input', annotationModes.ContinuousDraw)"
        :size="size"
        :buttonMode="annotationModes.ContinuousDraw"
        :annotationMode="context.annotationMode"
        :activeAnnotation="context.activeAnnotation"/>
      <annotation-mode-button
        :image="coloredAssetUrls.angle"
        :activeImage="activeAnnotationIcons.angle"
        title="Angle"
        @click="$emit('input', annotationModes.Angle)"
        :size="size"
        :buttonMode="annotationModes.Angle"
        :annotationMode="context.annotationMode"/>
    </v-col>
    <v-col cols="2">
        <label class="annotation-label">Shape Outline</label>
        <!-- <label class="annotation-label">Shape Fill</label> -->
        <label class="annotation-label">Font Size</label>
    </v-col>
    <v-col cols="4">
      <div class="mb-1">
        <circle-image-button
          :btnClass="shapeOutlineButtonClass"
          title="Shape Outline"
          :btnColor="annotationColor"
          :image="coloredAssetUrls.shapeOutline"
          @click="openShapeOutlineDialog"/>
      </div>
      <!--

      <div class="mb-1">
        <circle-image-button
          :btnClass="shapeFillButtonClass()"
          title="Shape Outline"
          :btnColor="shapeFillColor"
          :image="coloredAssetUrls.shapeFill"
          @click="openShapeFillDialog"/>
      </div>
      -->
      <div>
        <select-with-button
          :value="selectedTextSize"
          @input="$emit('setSize', $event)"
          :items="textSizes"
          name="textSize"/>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { ANNOTATION_MODES } from "../../../config/config";
import selectWithButton from "../../controls/SelectWithButton";
import annotationModeButton from "../../imageBrowser/controls/AnnotationModeButton";
import circleImageButton from "../../controls/CircleImageButton";
import { TEXT_SIZES } from "../../../config/config";

export default {
  name: "annotationDrawingButtonCollection",
  components: { selectWithButton, annotationModeButton, circleImageButton},
  props: {
    context: Object,
    isFlipped: Boolean,
    annotationColor: String,
    shapeFillColor: String,
    size: {type: String, default: "small"},
    syncContext: Object
  },
  data() {
    return {
      annotationModes: ANNOTATION_MODES,
      textSizes: TEXT_SIZES
    };
  },
  computed: {
    shapeOutlineButtonClass() {
      return "rounded-button shape-outline-button " + this.colorClass;
    },
    selectedTextSize() {
      return this.context && this.context.annotationTextSize;
    }
  },
  methods: {
    shapeFillButtonClass(){
      let btnClass = "rounded-button annotation-color-button " + this.colorClass;
      if (this.context.annotationMode == ANNOTATION_MODES.ShapeFill) btnClass += " selected-color";
      return btnClass;
    },
    openShapeOutlineDialog() 
    {
      this.$store.commit("setShapeOutlineSyncContext", this.syncContext);
      this.$store.commit("setShapeOutlineContext", this.context);
    },
    openShapeFillDialog() 
    {
      this.$store.commit("setShapeFillSyncContext", this.syncContext);
      this.$store.commit("setShapeFillContext", this.context);
    },
  }
};
</script>
